import { useIM, GroupStatusEvent } from '@wui/im'
import { defineStore } from 'pinia'
import { readonly, ref } from 'vue'

import { getLocalConferenceStart } from '../lib/conference-timer'

export const useCallSessionStartedTimestampStore = defineStore('call-session-duration-store', () => {
  const startedCallsTimestamps = ref(new Map<string, number>())

  const { onConferenceUpdated } = useIM()

  onConferenceUpdated((event: GroupStatusEvent) => {
    const { pServed, timestamp, extendedParams: { appointmentIsStarted, appointmentTimestampStart }} = event
    if (appointmentIsStarted && appointmentTimestampStart) {
      startedCallsTimestamps.value.set(
        pServed,
        getLocalConferenceStart(appointmentTimestampStart, timestamp),
      )
    } else if (startedCallsTimestamps.value.has(pServed)) {
      startedCallsTimestamps.value.delete(pServed)
    }
  })

  return {
    startedCallsTimestamps: readonly(startedCallsTimestamps),
  }
})
